import { render } from "./app.vue?vue&type=template&id=3d082c96"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&id=3d082c96&lang=scss"

import exportComponent from "/Users/liupingping/work/3/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__